import { Controller } from "@hotwired/stimulus"

/*
  Auto-submits the form it's attached to whenever a native control inside it
  fires a change event (native change events bubble, so this can sit on the
  <form> itself rather than on each individual control). Selecting a
  segmented-radio option is a single discrete click, not typed text, so this
  intentionally does not debounce, retry, or track in-flight requests: each
  change is exactly one immediate requestSubmit(), the same one-request-per-
  choice behavior the previous per-option submit buttons had.

  Example:
  <%= form_with url: some_path, method: :patch,
                data: { controller: "submit-on-change", action: "change->submit-on-change#submit" } do %>
    <%= render "shared/components/segmented_radio", ... %>
  <% end %>
*/
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
